module.exports = __webpack_public_path__ + "static/media/beautiful-stories.cdda7188.jpg";